export default "__VITE_ASSET__3MlU$HV5__"